import React from "react";

export default function footer() {
  return (
    <>
      <div className="container-fluid footer_box">
        <div className="credit1 ">
          {" "}
          <span>
            © 2024 Arka <span className="rohit_color">Jain</span> University,{" "}
            <span>All</span> Rights Reserved!
          </span>
        </div>

        <div className="credit2 text-muted">
          Developed By <span>Mr. Rohit Raj</span>
        </div>
      </div>

      <div />
    </>
  );
}
